import React from 'react';

interface PermissionAccessProps {
  modules: { name: string; description: string; permissions: string[] }[];
  selectedPermissions: Record<string, string[]>;
  togglePermission: (module: string, permission: string) => void;
  toggleSelectAll: (module: string) => void;
}

export const PermissionAccess: React.FC<PermissionAccessProps> = ({
  modules,
  selectedPermissions,
  togglePermission,
  toggleSelectAll,
}) => {
  const totalSelected = Object.values(selectedPermissions).flat().length;

  return (
    <div className="">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold">Permission Assignment</h2>
        <div className="text-sm text-gray-500">{totalSelected} Permissions Selected</div>
      </div>

      {/* Modules Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {modules.map((mod) => (
          <div key={mod.name} className="border rounded-xl p-4 bg-white shadow-sm">
            <h3 className="font-medium text-gray-800">{mod.name.toUpperCase()}</h3>
            <p className="text-xs text-gray-500 mb-3">{mod.description}</p>

            <div className="flex flex-wrap gap-3">
              {mod.permissions.map((perm) => (
                <label key={perm} className="flex items-center gap-1 text-sm">
                  <input
                    type="checkbox"
                    checked={selectedPermissions[mod.name]?.includes(perm) || false}
                    onChange={() => togglePermission(mod.name, perm)}
                    className="accent-pink-600"
                  />
                  {perm.charAt(0).toUpperCase() + perm.slice(1)}
                </label>
              ))}
              <label className="flex items-center gap-1 text-sm font-medium text-pink-600 cursor-pointer">
                <input
                  type="checkbox"
                  checked={selectedPermissions[mod.name]?.length === mod.permissions.length}
                  onChange={() => toggleSelectAll(mod.name)}
                  className="accent-pink-600"
                />
                Select All
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PermissionAccess;
